export default __webpack_public_path__ + "fe639626d3e37d990c781a651e62029c.png";